import moment from "moment-timezone";
import {handleUrlWithHashtag} from "../GetUrlParams";

function getCookie(name: string) {
    let regEx = new RegExp(name + "=([^;]+)");
    let cookieValue = regEx.exec(document.cookie);
    return (cookieValue != null) ? decodeURI(cookieValue[1]) : null;
}

export const Check24rCookie = () => {
    if(!getCookie('24rent')) {
        let timestamp = new Date();
        let ts = timestamp.toString();
        let parts = ts.split( "" ).reverse();
        let id = "";

        for( let i = 0; i < 32; ++i) {
            let index = Math.floor( Math.random() * ((parts.length - 1) + 1 ));
            id += parts[index];
        }
        let cookieExpires = moment().add(10, 'years').format('YYYY-MM-DDTHH:mm:ssZ');
        document.cookie = "24rent=" + id + '; expires=' + cookieExpires;
    }

    const campaign = new URLSearchParams(handleUrlWithHashtag()).get("campaign");
    if (campaign && !getCookie('lumo')) {
        if (campaign.toLowerCase() === 'lumo') {
            console.log("setting new lumo cookie")
            let date = new Date();
            date.setTime(date.getTime() + (365 * 24 * 60 * 60 * 1000)); // 1 year cookie
            document.cookie = "lumo=" + "lumo" + ";expires=" + date.toUTCString();
        }
    }

    return getCookie('24rent');
}

export interface ICustomerBehaviourData {
    utm_campaign?: string,
    utm_source?: string,
    utm_term?: string,
    utm_medium?: string,
    utm_content?: string,
    gclid?: string,
    cid?: string,
}

export const GetCustomerBehaviourParams = () => {
    const search = handleUrlWithHashtag();
    const utm_campaign = new URLSearchParams(search).get('utm_campaign') ?? '';
    const utm_source =  new URLSearchParams(search).get('utm_source') ?? '';
    const utm_term =  new URLSearchParams(search).get('utm_term') ?? '';
    const utm_medium =  new URLSearchParams(search).get('utm_medium') ?? '';
    const utm_content =  new URLSearchParams(search).get('utm_content') ?? '';
    const gclid =  new URLSearchParams(search).get('gclid') ?? '';
    const cid =  new URLSearchParams(search).get('cid') ?? '';

    return {utm_campaign: utm_campaign, utm_source: utm_source, utm_term: utm_term,
        utm_medium: utm_medium, utm_content: utm_content, gclid: gclid, cid: cid}
}

